import { addDoc, collection } from "firebase/firestore"
import { db } from "../config/firebase"

export async function submitOrder(order) {

    if(order?.items?.length === 0) {
        throw Error("Cart is empty")
    }

    return await addDoc(collection(db, "orders"), {
        data: order,
        user: "xVvJ0cgMw4Y1xItNteiSF15fn5O2",
        status: "orderready",
    })
}